import castArray from "lodash/fp/castArray";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";

import createImage from "./createImage";

export default function createImages({ signal, images: initialImages }) {
  const requests = flow(
    castArray,
    map(({ imageSet, images = [] }) =>
      createImage({ signal })({ images }).then((finalImage) => {
        if (!finalImage) {
          throw Error("no image");
        }
        return {
          imageSet,
          finalImage,
        };
      })
    )
  )(initialImages);

  return Promise.all(requests);
}
